import React, { Component } from 'react';
import { observer } from 'mobx-react';
import qualitystore from '../../QualityOfCare/stores/QualityStore';

@observer
class ProgressBar extends Component {
  render() {
    const { pages } = qualitystore;
    return (
      <>
        <div className="stepwizard stepwizard mb-5">
          <div className="stepwizard-row">
            {pages.map(page => (
              <a className={page.state} href={page.href} key={page.key}>
                <span className="stepwizard-badge" />
                <span className="stepwizard-title">{page.title}</span>
              </a>
            ))}
          </div>
        </div>
      </>
    );
  }
}

export default ProgressBar;